





















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class DividendsHistory extends Vue {
  get transactions (): any[] {
    return [1, 1, 1, 1, 1, 1, 1, 1, 1, 1].map(() => ({
      address: '13 James road, New York',
      date: 'Jan 26, 2020, 11:30pm EST',
      amount: '$4.89'
    })
    )
  }
}
